import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { IEdificios } from '../interfaces/Edificios';
import { environment } from '../../../environments/environment';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { IRegistroVentasItem } from '../interfaces/IRegistroVentaItems';
import { IContratos } from '../interfaces/Contratos';
import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';
import { IRegistroVentasCertificadas } from '../interfaces/RegistroVentasCertificadas';
import { ToastrService } from 'ngx-toastr';
import { IMeses } from '../interfaces/IMeses';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Component({
  selector: 'app-registroventacertificada',
  templateUrl: './registroventacertificada.component.html',
  styleUrls: ['./registroventacertificada.component.css']
})


export class RegistroventacertificadaComponent implements OnInit {

  @ViewChild('fileUploader') fileUploader: ElementRef;

  ventasCertificadas: IRegistroVentasCertificadas[] = [];
  edificios: Array<IEdificios>;
  contratos: IContratos[];
  FechaRegistroVenta: any;
  term: string;
  formRegistro: FormGroup;
  annios: Array<number> = [];
  meses: Array<IMeses> = [];
  anio: string;
  mes: string;
  submitted = false;


  constructor(
    private registroServicios: RegistroVentasService,
    private spinner: NgxSpinnerService,
    private readonly formBuilder: FormBuilder,
    private toaster: ToastrService,
    private httpClient: HttpClient) {

  }
  ngOnInit(): void {
    this.getEdificiosRegistro(environment.edificiosAutorizados, environment.marcasAutorizadas);
    this.construirFromularioRegistro();
    this.cargaAnnio();

  }

  construirFromularioRegistro() {
    this.formRegistro = this.formBuilder.group({
      edificio: ['', Validators.required],
      file: [null, Validators.required],
      name: [null, Validators.required],
      size: [null, Validators.required]

    });
  }

  get f() { return this.formRegistro.controls; }

  getEdificiosRegistro(edificios: string, marcas: string) {
    this.registroServicios.getEdificiosRegistro(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }
      },
      (error: ErrorResponse) => {
        console.error(error);
      }
    );
  }

  getContratos() {
    if (this.anio == undefined || this.mes == undefined) {
      this.submitted = true;
      return;
    }
    this.spinner.show();
    this.registroServicios.getContratos(this.formRegistro.value.edificio, environment.marcasAutorizadas, this.mes, this.anio).subscribe(
      contrato => {
        if (contrato.length != 0) {
          this.contratos = contrato;
          this.setContratos(this.contratos);
          this.spinner.hide();
        }
        else {
          Swal.fire('No se encontraron registros.');
          this.spinner.hide();
        }
      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  guardarRegistroVentas(item: IRegistroVentasCertificadas) {
    var registro = item;
    var fileExtension = '.' + this.formRegistro["controls"].name.value.split('.').pop();
    registro.venta = +item.venta;
    registro.documentos = this.formRegistro["controls"].file.value;
    registro.nombreDocumento = Math.random().toString(36).substring(7) + new Date().getTime() + fileExtension;
    registro.estado = 'Sin aprobar';
    registro.periodo = this.anio + this.mes;
    registro.fechaRegistroVenta = new Date(this.anio + "-" + this.mes + "-" + "01");

    this.spinner.show();
    let result;;
    if (registro.nombreDocumento != null) {

      this.registroServicios.guardarRegistroVentaCertificada(registro)
        .subscribe(e => {
          result = e;
          if (result) {
            this.toaster.success('Pactia Ventas', 'Se ha guardado con éxito!.');
            this.limpiarValores();
          }
          else {
            this.toaster.warning('', 'Ya existe un registro de venta para esta marca, si quiere modificarla vaya a la opción de consulta.');
            this.limpiarValores();
          }
          this.spinner.hide();

        }, (error: ErrorResponse) => {
          console.error(error);
          this.spinner.hide();
        }

        );
    }
    else {
      this.spinner.hide();
      this.toaster.error('', 'Debe registrar la venta certificada o adjuntar un soporte.');

    }

  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onBlurMethod() {

    /*if (this.ItemRegistro.Ventas !== '') {

      this.enabledButton = true;
    } else {
      this.enabledButton = false;
    }*/
  }

  cargaAnnio() {
    var annioActual = new Date().getFullYear();

    for (let i = 2021; i <= annioActual; i++) {
      this.annios.push(i);
    }

  }

  cargarMeses() {
    this.meses = [];
    if (this.anio != "2021") {
      this.meses.push(
        { Value: '1', Text: 'Enero' },
        { Value: '2', Text: 'Febrero' },
        { Value: '3', Text: 'Marzo' },
        { Value: '4', Text: 'Abril' },
        { Value: '5', Text: 'Mayo' },
        { Value: '6', Text: 'Junio' },
        { Value: '7', Text: 'Julio' },
        { Value: '8', Text: 'Agosto' },
        { Value: '9', Text: 'Septiempre' },
        { Value: '10', Text: 'Octubre' },
        { Value: '11', Text: 'Noviembre' },
        { Value: '12', Text: 'Diciembre' }
      );
    } else {
      this.meses.push(
        { Value: '6', Text: 'Junio' },
        { Value: '7', Text: 'Julio' },
        { Value: '8', Text: 'Agosto' },
        { Value: '9', Text: 'Septiempre' },
        { Value: '10', Text: 'Octubre' },
        { Value: '11', Text: 'Noviembre' },
        { Value: '12', Text: 'Diciembre' }
      );
    }
  }





  setContratos(contratos: IContratos[]) {
    this.ventasCertificadas = <IRegistroVentasCertificadas[]>[];
    for (let i = 0; i < contratos.length; i++) {
      const item = <IRegistroVentasCertificadas>{};
      item.marca = contratos[i].nombreMarca;
      item.codMarca = contratos[i].zzcodmarca;
      item.contrato = contratos[i].recnnrcontrato;
      item.locales = contratos[i].txtlgobjeto;
      item.comentarios = '';
      item.edificio = contratos[i].nombreEdificio;
      item.codEdificio = contratos[i].codedificio;
      item.estado = ''
      item.venta = 0;
      item.urlSoportes = '';
      item.fechaRegistro = new Date;
      item.usuario = environment.userEmailLogged;
      item.fechaRegistroVenta = new Date;
      item.sociedad = contratos[i].bukrscontrato;
      item.tipoContrato = contratos[i].zzrentpercent == 0 ? 'Fijo' : 'Variable';
      item.porcentaje = contratos[i].zzrentpercent;
      this.ventasCertificadas.push(item);

    }
  }


  onFileChange(event) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.formRegistro.patchValue({
          file: reader.result,
          name: file.name,
          size: file.size
        });
      };
    }
  }
  limpiarValores() {
    this.ventasCertificadas[0].venta = 0;
    this.fileUploader.nativeElement.value = '';
    this.fileUploader.nativeElement.name = '';
    this.formRegistro.reset();
  }


  error: any = { isError: false, errorMessage: '' };

  compareTwoDates() {
    var fecha = formatDate(this.FechaRegistroVenta, 'yyyy/MM/dd', 'en-US');
    if (new Date(fecha) > new Date()) {
      this.error = { isError: true, errorMessage: 'La fecha no puede ser mayor al dia actual' };
    }
    else {
      this.error = { isError: false, errorMessage: '' };
    }
  }

  showInvoice(registro: IRegistroVentasCertificadas) {
    registro.sociedad = registro.sociedad.trim();
    this.registroServicios.consultarFactura(registro, this.mes, this.anio)
      .then((response: any) => {
        this.httpClient.get('assets/templates/invoice-template.txt', { responseType: 'text' })
          .toPromise().then((htmlText: string) => {
            Swal.fire({ html: this.formatHtml(htmlText, response), confirmButtonText: 'Aceptar' });
          });

      }).catch
      ((error) => {
        switch (error.status) {
          case 404: {
            Swal.fire('Lo sentimos', 'No se encontró una factura para el registro solicitado');
            break;
          }
          default: {
            Swal.fire('Lo sentimos', 'No se pudo completar la solicitud');
          }
        }
        console.log(error)
      }
      );
  }

  private formatHtml(htmlText: string, data: any): string {
    const output = htmlText.replace(/{ventaCertificada}/g, this.formatToCurrency(data.ventaCertificada))
      .replace(/{variablePactado}/g, data.variablePactado)
      .replace(/{minimoMensual}/g, this.formatToCurrency(data.minimoMensual))
      .replace(/{variableFacturar}/g, this.formatToCurrency(data.variableFacturar));
    return output;
  }

  private formatToCurrency = amount => {
    return "$" + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  };

  onSubmit(item: IRegistroVentasCertificadas) {
    this.submitted = true;
    if (this.anio == undefined) {
      return;
    }
    if (this.mes == undefined) {
      return;
    }
    else {
      this.guardarRegistroVentas(item);
    }
  }
}


